export default () => {
    const modals = document.querySelectorAll("[data-modal]");
    modals.forEach(function (trigger) {
        document.addEventListener("keydown", (event) => {
            let kdModal = document.getElementById(trigger.dataset.modal)
            let searchInput = document.getElementById("search");
            if (event.code === 'Escape' && kdModal.classList.contains('open')) {
                kdModal.classList.remove("open")
                searchInput.value = "";
            }
        });
        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            const modal = document.getElementById(trigger.dataset.modal);
            modal.classList.add("open");
            setTimeout(() => document.getElementById('search').focus(), 500)
            const exits = modal.querySelectorAll(".modal-exit");
            exits.forEach(function (exit) {
                exit.addEventListener("click", function (event) {
                    event.preventDefault();
                    modal.classList.remove("open");
                });
            });
        });
    });
//modal windows
//see https://codepen.io/deineko/pen/PoxNYPJ
// focus on search field
    var searchBtn = document.getElementById("toggleSearch");
    var searchInput = document.getElementById("search");
    searchBtn.addEventListener("click", () => {
        searchInput.focus();
        // searchInput.setAttribute("autofocus", "");
        // searchInput.setAttribute("value", "Ура");
        searchInput.setAttribute("placeholder", "Поиск");
    });

    searchInput.addEventListener("click", () => {
        searchInput.setAttribute("value", "");
        searchInput.setAttribute("placeholder", "");
    });
}